import { CpaStatus } from '../data-layer/cpa/types';
import { useCurrentUser } from '../routing/users/useCurrentUser';
import { isBlogger, isSuperAdmin } from './accessService';
import { useExperimentFlag } from './useExperimentFlag';

export const useIsAdvertisingCatalogEnabled = () => {
    const currentUser = useCurrentUser();
    const role = currentUser?.role;
    const cpaStatus = currentUser?.cpaStatus;

    const flagEnabled = Number(useExperimentFlag('advertising_catalog_enabled')) === 1;

    return (
        flagEnabled &&
        (isBlogger(role) || isSuperAdmin(role)) &&
        cpaStatus &&
        [CpaStatus.TRIAL, CpaStatus.ACCEPTED, CpaStatus.MODERATION].includes(cpaStatus)
    );
};
